<div class="statistics-metric-card" [ngClass]="colorClasses">
  <div class="card-content">
    <div class="card-header">
      <i *ngIf="icon" [class]="icon + ' card-icon'" [ngClass]="iconColorClasses"></i>
      <h3 class="card-title">{{ title }}</h3>
    </div>
    
    <div class="card-body">
      <div class="metric-value-wrapper">
        <div class="metric-value" *ngIf="!loading">
          {{ value | number:'1.0-2' }}
        </div>
        <div class="metric-value skeleton" *ngIf="loading">
          <div class="skeleton-bar"></div>
        </div>
        
        <div class="metric-subtitle" *ngIf="subtitle && !loading">
          {{ subtitle }}
        </div>
      </div>
      
      <div class="metric-trend" *ngIf="trend && !loading">
        <i [class]="trendIcon" [ngClass]="trendColor"></i>
        <span [ngClass]="trendColor">
          {{ trend.value > 0 ? '+' : '' }}{{ trend.value | number:'1.0-1' }}%
        </span>
        <span class="trend-label" *ngIf="trend.label">{{ trend.label }}</span>
      </div>
    </div>
  </div>
</div>

